import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface UsersParameter {
  data: string[] | null
}

export interface getUsersParameterState {
  isLoading: boolean
  data: UsersParameter | null
  error: string | null
  httpStatus: number | null
}

const initialState: getUsersParameterState = {
  isLoading: false,
  data: null,
  error: null,
  httpStatus: 0
}

export const getUsersSlice = createSlice({
  name: 'UsersFilterParameter',
  initialState,
  reducers: {
    getUsersDataLoading: (state): getUsersParameterState => {
      return {
        isLoading: true,
        data: null,
        error: null,
        httpStatus: 0
      }
    },
    getUsersDataError: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>): getUsersParameterState => {
      return {
        isLoading: false,
        data: null,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    },
    getUsersData: (state, action: PayloadAction<any>): getUsersParameterState => {
      return {
        isLoading: false,
        data: action.payload.data,
        error: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const { getUsersDataLoading, getUsersDataError, getUsersData } = getUsersSlice.actions
export default getUsersSlice.reducer
